function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useMemo } from 'react';
import styles from './LoadingPlaceholder.module.scss';
import { createPortal } from 'react-dom';
import I18n, { formatI18n } from '../../I18n/I18n/I18n';
import uuid from '../../utils/uuid';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import compose from '../../utils/compose';
import DefaultPlaceholder from '../DefaultPlaceholder';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import en from './locales/LoadingPlaceholder.en.json';
import { injectIntl } from 'react-intl';
var messages = normalizeLocaleData(en, '@dm/components.loading-placeholder');
function AriaAnnounce(_ref) {
  var shouldAnnounce = _ref.shouldAnnounce,
    loading = _ref.loading,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '@dm/components.loading-placeholder.component' : _ref$name,
    intl = _ref.intl;
  var message = name && formatI18n(intl, name);
  var i18n = useMemo(function () {
    return {
      id: "@dm/components.loading-placeholder.".concat(loading ? 'loading' : 'loaded'),
      values: {
        name: message
      }
    };
  }, [loading, message]);
  return createPortal(/*#__PURE__*/React.createElement("div", {
    role: "alert",
    "aria-live": "assertive",
    "aria-relevant": "all",
    className: styles.aria
  }, shouldAnnounce && /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  })), document.body);
}
var WithIntlAriaAnnounce = compose(withAdditionalIntl({
  messages: messages,
  path: 'LoadingPlaceholder/LoadingPlaceholder/locales/LoadingPlaceholder',
  namespace: '@dm/components.loading-placeholder'
}), injectIntl)(AriaAnnounce);
export default function LoadingPlaceholder(_ref2) {
  var _ref2$shouldAnnounce = _ref2.shouldAnnounce,
    shouldAnnounce = _ref2$shouldAnnounce === void 0 ? true : _ref2$shouldAnnounce,
    name = _ref2.name,
    loaded = _ref2.loaded,
    id = _ref2.id,
    _ref2$rows = _ref2.rows,
    rows = _ref2$rows === void 0 ? 5 : _ref2$rows,
    _ref2$delay = _ref2.delay,
    delay = _ref2$delay === void 0 ? 1500 : _ref2$delay,
    _ref2$wait = _ref2.wait,
    wait = _ref2$wait === void 0 ? 250 : _ref2$wait,
    component = _ref2.component,
    children = _ref2.children;
  var Component = component;
  var _useState = useState(loaded),
    _useState2 = _slicedToArray(_useState, 2),
    showChildren = _useState2[0],
    setShowChildren = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPlaceholder = _useState4[0],
    setShowPlaceholder = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showAnnounce = _useState6[0],
    setShowAnnounce = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    inWait = _useState8[0],
    setInWait = _useState8[1];
  var normalizedId = useMemo(function () {
    return id || "style_".concat(uuid());
  }, [id]);
  useEffect(function () {
    var loadingTimeout = setTimeout(function () {
      setShowPlaceholder(true);
      setInWait(true);
    }, delay);
    var waitTimeout = setTimeout(function () {
      setInWait(false);
    }, delay + wait);
    return function () {
      clearTimeout(loadingTimeout);
      clearTimeout(waitTimeout);
    };
  }, [delay, wait, setShowPlaceholder, setInWait]);
  useEffect(function () {
    if (loaded && !inWait) {
      setShowChildren(true);
    }
    if (!loaded && showPlaceholder) {
      setShowAnnounce(true);
    }
  }, [loaded, inWait, showPlaceholder]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showChildren && children, !showChildren && showPlaceholder &&
  /*#__PURE__*/
  /* show placeholder, either custom one or default */
  React.createElement("div", {
    "aria-hidden": true,
    className: styles.container
  }, Component ? /*#__PURE__*/React.createElement(Component, null) : /*#__PURE__*/React.createElement(DefaultPlaceholder, {
    id: normalizedId,
    rows: rows
  })), shouldAnnounce && /*#__PURE__*/React.createElement(WithIntlAriaAnnounce, {
    shouldAnnounce: showAnnounce,
    loading: !showChildren,
    name: name
  }));
}